<template>
    <v-app-bar class="app-top-bar" color="primary-600" height="72" :elevation="0">
        <div class="app-top-bar-wrap">
            <div class="app-top-bar-content">
                <div class="left-actions">
                    <router-link to="/">
                        <div class="app-top-bar-logo">
                            <v-img :src="logoImg" :width="228"></v-img>
                        </div>
                    </router-link>
                </div>
                <div v-if="isAdminUser || isReaderUser" class="middle-actions">
                    <AppSearchBar></AppSearchBar>
                </div>

                <div class="right-actions">
                    <AppNavigation></AppNavigation>
                    <AppLangBar></AppLangBar>
                    <AppUserBar></AppUserBar>
                </div>
            </div>
        </div>
    </v-app-bar>
</template>

<script lang="ts" setup>
import { includes } from 'lodash';
import AppUserBar from './AppUserBar.vue';
import AppNavigation from './AppNavigation.vue';
import AppSearchBar from './AppSearchBar.vue';
import AppLangBar from './AppLangBar.vue';
import useAuthStore from '../../auth/store/auth.store';
import { storeToRefs } from 'pinia';

import logoImg from '@/assets/logo.svg';

const authStore = useAuthStore();
const { selectAccessTokenRoles } = storeToRefs(authStore);
const isAdminUser = !!includes(
    selectAccessTokenRoles.value,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME
);
const isReaderUser = !!includes(
    selectAccessTokenRoles.value,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    import.meta.env.VITE_MSAL_READER_ROLE_NAME
);
</script>
<style lang="scss">
.app-top-bar {
    &-wrap {
        width: 100%;
    }
    &-content {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .left-actions {
            background-color: transparent;
            display: flex;
            align-items: center;
            padding-right: 16px;
        }
        .middle-actions {
            background-color: transparent;
        }
        .right-actions {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
        }
    }
    .v-app-bar-title {
        max-width: 250px;
        width: 100%;
    }
    &-logo {
        background-image: url('../../../assets/logo.svg');
    }
}
</style>
